export const FIELD_INITIAL = 'De';
export const FIELD_FINAL = 'Até';
export const PORCENTAGEM_COMISSAO = 'Comissão';
export const PORCENTAGEM_PAGTO_DIRETO = 'Pagamento Direto';
export const TRASH_HINT = 'Excluir Faixas';
export const LABEL_REGRA = 'Regra de Comissionamento do Comercial';
